<template>
  <div class="content ht-100v pd-0">
    <!-- <div class="content-header" slot="content-header">
      Тохиргоо
    </div> -->
    <div class="content-body pd-0">
      <div class="container pd-x-0 mg-b-0">
        <div class="row">
          <div class="col-3">
            <label
              class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10"
              >Цэс</label
            >
            <nav class="nav nav-sidebar tx-13">
              <a
                v-if="$store.state.app.activeGroup.id != 9249"
                href="/#/user/settings/1"
                class="nav-link"
                :class="{ active: $route.params.mode == '1' }"
              >
                <feather class="ht-25-f wd-25-f" type="lock"></feather>
                <span>Нууц үг солих</span>
                <span class="badge"
                  ><feather type="chevron-right"></feather
                ></span>
              </a>
              <a
                v-if="$store.state.app.activeGroup.id != 9249"
                href="/#/user/settings/2"
                class="nav-link"
                :class="{ active: $route.params.mode == '2' }"
              >
                <feather class="ht-25-f wd-25-f" type="mail"></feather>
                <span>И-мэйл солих</span>
                <span class="badge"
                  ><feather type="chevron-right"></feather
                ></span>
              </a>
              <a
                href="/#/user/settings/3"
                class="nav-link"
                :class="{ active: $route.params.mode == '3' }"
              >
                <feather class="ht-25-f wd-25-f" type="mail"></feather>
                <span>Хоёр нөхцөлт баталгаажуулалт</span>
                <span class="badge"
                  ><feather type="chevron-right"></feather
                ></span>
              </a>
              <router-link
              v-if="$store.state.app.activeGroup.id != 9249"
              :to="{ name: 'userProfile' }"
              class="nav-link"
            >
            <feather class="ht-25-f wd-25-f" type="user"></feather>
              Мэдээлэл шинэчлэх
              <span class="badge"
                  ><feather type="chevron-right"></feather
                ></span>
            </router-link>
              <!-- <a href="" class="nav-link">
                        <feather type="user"></feather>
                        <span>Мэдээлэл шинэчлэх</span>
                        <span class="badge"><feather type="chevron-right"></feather></span>
                    </a> -->
            </nav>
          </div>
          <div class="col">
            <div class="card">
              <div class="card-header">Тохиргоо</div>
              <div v-if="$route.params.mode == '1'" class="card-body">
                <Form :model="passModel">
                  <FormItem label="Хуучин нууц үг" class="m-b-sm">
                    <Input
                      v-model="passModel.old"
                      placeholder="___"
                      type="password"
                    />
                  </FormItem>
                  <FormItem label="Шинэ нууц үг" class="m-b-sm">
                    <Input
                      v-model="passModel.new"
                      placeholder="___"
                      type="password"
                    />
                  </FormItem>
                  <FormItem label="Шинэ нууц үг давт" class="m-b-sm">
                    <Input
                      v-model="passModel.rep"
                      placeholder="___"
                      type="password"
                    />
                  </FormItem>
                </Form>
              </div>
              <div v-else-if="$route.params.mode == '2'" class="card-body">
                <div role="alert" class="el-alert el-alert--info is-light">
                  <i class="el-alert__icon el-icon-info is-big"></i>
                  <div class="el-alert__content">
                    <span class="el-alert__title is-bold">Алхам 1</span>
                    <p class="el-alert__description">
                      Таны оруулсан и-мэйл хаягаар баталгаажуулах код бүхий
                      и-мэйл очно
                    </p>
                  </div>
                </div>

                <Form :model="mailModel">
                  <FormItem
                    label="Таны одоогийн системд бүртгэлтэй и-мэйл хаяг"
                  >
                    <Input
                      :value="$store.state.user.userInfo.mail"
                      type="text"
                      disabled
                    />
                  </FormItem>
                  <FormItem label="Шинэ и-мэйл хаягаа оруулна уу">
                    <Input
                      v-model="mailModel.mail"
                      placeholder="___"
                      type="text"
                    />
                  </FormItem>
                </Form>
              </div>
              <div v-else-if="$route.params.mode == '3'" class="card-body">
                <div role="alert" class="el-alert el-alert--info is-light">
                  <i class="el-alert__icon el-icon-info is-big"></i>
                  <div class="el-alert__content">
                    <span class="el-alert__title is-bold">Алхам 1</span>
                    <p class="el-alert__description">
                      Google Authenticator апп татах
                    </p>
                  </div>
                </div>
                <div class="row no-gutters">
                  <div class="col-6">
                    <a
                      class="bd pd-20 mg-20 d-flex"
                      role="button"
                      target="_blank"
                      href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                    >
                      <div>
                        <span class="tw-store-button-desc tw-lh-normal"
                          >IOS апп татах</span
                        >
                        <h3 class="tw-store-button-desc tw-lh-normal">
                          App Store
                        </h3>
                      </div>
                      <div class="mg-l-auto">
                        <img src="assets/svg/apple.svg" />
                      </div>
                    </a>
                  </div>
                  <div class="col-6">
                    <a
                      class="bd pd-20 mg-20 d-flex"
                      role="button"
                      target="_blank"
                      href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=mn&gl=US"
                    >
                      <div>
                        <span class="tw-store-button-desc tw-lh-normal"
                          >Android апп татах</span
                        >
                        <h3 class="tw-store-button-desc tw-lh-normal">
                          Google Play
                        </h3>
                      </div>
                      <div class="mg-l-auto">
                        <img src="assets/svg/android.svg" />
                      </div>
                    </a>
                  </div>
                </div>
                <div role="alert" class="el-alert el-alert--info is-light">
                  <i class="el-alert__icon el-icon-info is-big"></i>
                  <div class="el-alert__content">
                    <span class="el-alert__title is-bold">Алхам 2</span>
                    <p class="el-alert__description">QR Code уншуулах</p>
                  </div>
                </div>
                <div class="pd-20 text-center">
                  <img class="wd-150" :src="`data:image/png;base64,${qr.qr}`" />
                </div>
                <div role="alert" class="el-alert el-alert--info is-light">
                  <i class="el-alert__icon el-icon-info is-big"></i>
                  <div class="el-alert__content">
                    <span class="el-alert__title is-bold">Алхам 3</span>
                    <p class="el-alert__description">
                      Хоёр нөхцөлт баталгаажуулалтыг идэвхжүүлэх
                    </p>
                  </div>
                </div>
                <div class="pd-20 text-center">
                  <input
                    v-model="qr.isDisabled"
                    type="checkbox"
                    id="googlechk"
                  />
                  <label for="googlechk" class="mg-l-10">Идэвхжүүлэх</label>
                </div>
              </div>
              <div class="card-footer">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button
                    @click="change()"
                    type="button"
                    class="btn btn-primary"
                  >
                    Хадгалах
                  </button>
                  <button
                    @click="$router.push({ name: 'home' })"
                    type="button"
                    class="btn btn-danger"
                  >
                    Болих
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-3">
            <div>
              <img
                :src="`${$store.state.user.userInfo.avator}`"
                style="width: 64px; height: 64px"
              />
              <h5 class="mg-t-20 tx-spacing--1">
                {{ $store.state.user.userInfo.fullName }}
              </h5>
              <h6 class="mg-t-20 tx-spacing--1">
                №: {{ $store.state.user.userInfo.profileId }}
              </h6>
            </div>

            <div class="mg-t-25">
              <label
                class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15"
                >Холбоо барих мэдээлэл</label
              >
              <ul class="list-unstyled profile-info-list">
                <li>
                  <feather type="briefcase" class="mr-2"></feather>
                  <span class="text-muted">{{
                    $store.state.user.userInfo.depart +
                      ", " +
                      $store.state.user.userInfo.position
                  }}</span>
                </li>
                <li>
                  <feather type="home" class="mr-2"></feather>
                  <span class="text-muted">{{
                    $store.state.user.userInfo.groupName
                  }}</span>
                </li>
                <li>
                  <feather type="phone" class="mr-2"></feather>
                  <span class="">{{ $store.state.user.userInfo.mobile }}</span>
                </li>
                <li>
                  <feather type="mail" class="mr-2"></feather>
                  <span class="">{{ $store.state.user.userInfo.mail }}</span>
                </li>
                <li>
                  <feather type="git-branch" class="mr-2"></feather>
                  <span class="">Бүтээл хувилбар: 3902</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      :visible.sync="modalCode"
      title="Алхам 2"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div role="alert" class="el-alert el-alert--info is-light">
        <i class="el-alert__icon el-icon-info is-big"></i>
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">Алхам 2</span>
          <p class="el-alert__description">
            Таны <b>{{ mailModel.mail }}</b> хаяг руу баталгаажуулах код
            амжилттай илгээлээ. Баталгаажуулах кодыг доорх талбарт оруулаад
            баталгаажуулах дарна уу
          </p>
        </div>
      </div>
      <div class="text-muted text-right m-l-md">
        жич: Баталгаажуулах и-мэйл таны INBOX folder-т очоогүй бол SPAM
        folder-оо шалгана уу.
      </div>
      <Input
        v-model="mailModel.key"
        placeholder="И-Мэйлээр очсон кодыг оруулна уу"
        type="text"
      />
      <span slot="footer" class="dialog-footer">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button @click="acceptMail()" type="button" class="btn btn-primary">
            Баталгаажуулах
          </button>
        </div>
      </span>
    </Dialog>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  Input,
  FormItem,
  Notification,
  Dialog
  //   DatePicker,
  //   Divider,
  //   InputNumber,
  //   Select,
  //   Option
} from "element-ui";

import { request } from "@/api/all";
import { mapActions } from "vuex";

const crypto = require("crypto");
const base32 = require("hi-base32");

export default {
  components: {
    Form,
    FormItem,
    Input,
    Dialog
  },
  data() {
    return {
      passModel: {
        old: "",
        new: "",
        rep: ""
      },
      mailModel: {
        mail: "",
        key: ""
      },
      modalCode: false,
      qr: {
        isDisabled: false,
        qr: null
      }
    };
  },
  mounted() {
    //console.log('mntd');
    if (this.$route.params.mode == 3) {
      this.loadUserAuth();
    }
  },
  methods: {
    ...mapActions(["handleUserMail"]),
    acceptMail() {
      request({
        api: {
          method: "POST",
          url: "auth/AcceptChangeMail"
        },
        data: {
          key: this.mailModel.key
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          Notification({
            title: "Амжилттай",
            message: "Таны и-мэйл хаяг амжилттай солигдлоо.",
            type: "success"
          });

          this.modalCode = false;
          this.mailModel.key = "";
          this.mailModel.mail = "";

          this.handleUserMail({ mail: this.mailModel.mail });
        }
      });
    },
    changeMail() {
      let errs = [];
      if (this.mailModel.mail.length <= 0) {
        errs.push("Шинэ и-мэйл хаягаа оруулна уу.");
      }
      if (errs.length == 0) {
        request({
          api: { method: "POST", url: "auth/RequestChangeMail" },
          data: { mail: this.mailModel.mail },
          store: this.$store
        }).then(res => {
          if (res != false) {
            Notification({
              title: "Мэдэгдэл",
              message:
                "Таны шинэ и-мэйл хаяг руу мэйл илгээлээ. И-мэйлээр очсон баталгаажуулах кодыг оруулж хүсэлтээ баталгаажуулна уу.",
              duration: 0,
              type: "warning"
            });

            this.modalCode = true;
          }
        });
      } else {
        Notification({
          title: "Мэдэгдэл",
          message: errs[0],
          type: "warning"
        });
      }
    },
    change() {
      if (this.$route.params.mode == "2") {
        this.changeMail();
      } else if (this.$route.params.mode == "1") {
        this.changePass();
      } else if (this.$route.params.mode == "3") {
        this.changeAuth();
      }
    },
    changePass() {
      let errs = [];

      if (this.passModel.old.length <= 0) {
        errs.push("Хуучин нууц үг оруулна уу !");
      }
      if (this.passModel.new.length <= 0) {
        errs.push("Шинэ нууц үг оруулна уу !");
      } else if (this.passModel.new.length < 6) {
        errs.push("Нууц үг хамгийн багадаа 6 тэмдэгт байна !");
      } else if (this.passModel.new != this.passModel.rep) {
        errs.push("Шинэ нууц үг зөв давтан оруулна уу");
      }

      if (errs.length == 0) {
        request({
          api: { method: "POST", url: "auth/ChangePassword" },
          data: {
            oldPassword: this.passModel.old,
            password: this.passModel.new
          },
          store: this.$store
        }).then(res => {
          if (res != false) {
            Notification({
              title: "Амжилттай",
              message: res.msg,
              type: "success"
            });

            this.passModel.old = "";
            this.passModel.new = "";
            this.passModel.rep = "";
          }
        });
      } else {
        Notification({
          title: "Мэдэгдэл",
          message: errs[0],
          type: "error"
        });
      }
    },
    loadUserAuth() {
      const randomBuffer = crypto.randomBytes(20);
      let _token = base32.encode(randomBuffer).replace(/=/g, "");

      request({
        api: { method: "POST", url: "Auth/Post2FactorToken" },
        data: {
          token: _token,
          isDisabled:
            this.$store.state.app.activeGroup.id == 9241 ||
            this.$store.state.app.activeGroup.id == 9249
              ? false
              : true
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.qr.isDisabled = !res.data.isDisabled;
          this.qr.qr = res.data.qr;
          //console.log(res);
        }
      });
    },
    changeAuth() {
      request({
        api: { method: "POST", url: "Auth/Post2FactorToken" },
        data: { token: null, isDisabled: !this.qr.isDisabled },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.loadUserAuth();
        }
      });
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.mode == 3) {
        this.loadUserAuth();
      }
    }
  }
};
</script>

<style></style>
